import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';

import * as constants from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import TableCustom from 'views/pages/components/TableCustom';

import {Button, Card, CardBody, CardHeader, Col, Container, Row,} from 'reactstrap';
import notify from '@utils/notify';

export default function UnauthorizedDealers() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (Cookies.get('grs_token')) {
      let grs_token = Cookies.get('grs_token')
      axios({
        method: 'GET',
        url: constants.API_URL + '/staff/payments/unauthorized-dealers',
        headers: {
          Authorization: 'Bearer ' + grs_token
        },
      })
        .then(response => {
          console.log('res :: ', response.data)
          let data = response.data
          setItems(data.data.items)

          setTimeout(() => {
            setLoading(false)
          }, 1000);
        })
        .catch(error => {
          console.error('error :: ', error)
          setLoading(false)
          notify.warning('Warning', error.response ? error.response.statusText : 'Error occurred!')
        })
    }
  }, [])

  const goDealersPayments = () => {
    history.push({
      pathname: '/admin/staff/payments'
    })
  }

  return (
    <>
      <CardsHeader name="Payments" parentName="Payments Management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <div className="d-flex justify-content-between">
                  <div>
                    <h1 className="title mb-0">Dealers not supporting direct payments yet</h1>
                  </div>
                  <Button className="h-50" color="success" type="button" onClick={() => goDealersPayments()}>Back to Dealers Payments</Button>
                </div>
              </CardHeader>
              <CardBody>
                <TableCustom 
                  loading={loading}
                  items={items}
                  keyField={`name`}
                  searchField={false}
                  columns={[
                    {
                      dataField: "name",
                      text: "Dealer",
                      sort: true
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}